// extracted by mini-css-extract-plugin
export var quantityInput = "_jf-0";